import { TUnit } from "../../types/gui/field.types";

export const UNITS: TUnit[] = ["px", "em", "%", "vh", "vw", "auto"];
